// export const ipAddress = 'https://waytrixback.onrender.com';
//'https://waytrixback.onrender.com'; // Change this to your actual IP address


// export const ipAddress = 'http://192.168.1.103:4000'; // Change this to your actual IP address
export const ipAddress = 'https://back.way-trix.com'; // Change this to your actual IP address
//https://back.way-trix.com
// export const ipAddress = 'https://oldwaytrixbackend.onrender.com';
